import { createTheme } from "@mui/material/styles";

// Keep the Supplier Portal on the same Comfort Line visual system used by
// the Client / Partner Portal: Comfort red, white surfaces, light-grey page
// background and Calibri/Segoe UI typography.
const supplierTheme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#d32f2f", dark: "#b71c1c" },
    secondary: { main: "#000000" },
    error: { main: "#d32f2f" },
    success: { main: "#2e7d32" },
    background: { default: "#f5f5f5", paper: "#ffffff" },
    text: { primary: "#111111", secondary: "#666666" },
    divider: "rgba(0,0,0,0.12)",
  },
  typography: {
    fontFamily: 'Calibri, "Segoe UI", Arial, sans-serif',
    button: { textTransform: "none", fontWeight: 600 },
    h5: { fontWeight: 800 },
    h6: { fontWeight: 700 },
  },
  shape: { borderRadius: 4 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: 'Calibri, "Segoe UI", Arial, sans-serif',
          backgroundColor: "#f5f5f5",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { textTransform: "none", fontWeight: 600 },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          "&.Mui-selected": {
            backgroundColor: "rgba(0,0,0,0.07)",
            color: "#d32f2f",
          },
          "&.Mui-selected:hover": {
            backgroundColor: "rgba(0,0,0,0.09)",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { paddingTop: 10, paddingBottom: 10 },
        head: {
          fontWeight: 700,
          color: "#111111",
          backgroundColor: "#fafafa",
          whiteSpace: "nowrap",
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: { maxWidth: "100%", overflowX: "auto", WebkitOverflowScrolling: "touch" },
      },
    },
    MuiTextField: { defaultProps: { size: "small" } },
  },
});

export default supplierTheme;
